module.exports = __webpack_public_path__ + "static/media/gr.aa61f4e5.png";